import { React, Component, PropTypes } from 'utils';

const types = {
	keyword: 'fa fa-tag',
	job: 'fa fa-user',
	search: 'fa fa-search',
	area: 'fa fa-map-marker',
	city: 'fa fa-map-marker',
	add: 'fa fa-filter',
	language: 'fa fa-comment',
	languageFilter: 'fa fa-comment',
	salary: 'fa fa-credit-card',
	days: 'fa fa-fire',
	skill: 'fa fa-certificate',
	zip: 'fa fa-envelope',
	question: 'fa fa-question-circle',
}

export default class Icon extends Component {

	static propTypes = {
		type: PropTypes.string
	}

	render() {
		return <i className={ types[this.props.type] }></i>
	}
}




// WEBPACK FOOTER //
// ./src/modules/app/search/Icon.js